module.exports = __webpack_public_path__ + "img/shixunke.8f4ad816.png";